<template>
  <BaseFormLayout
    :title="
      editMode
        ? `Edit Adhoc ${orderModule.order}`
        : `Add Adhoc ${orderModule.order}`
    "
    :nonFieldErrors="formErrors.non_field_errors"
  >
    <template #actions>
      <SecondaryButton
        v-if="!editMode"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        @click="submitForm()"
        :disabled="!isValid"
        btnClass="text-uppercase rounded-lg"
        name="Submit"
      >
      </PrimaryButton>
    </template>
    <template #content>
      <v-form
        v-model="isValid"
        ref="orderForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-row class="ma-0">
          <v-col>
            <v-card elevation="0" class="pa-4 rounded-lg">
              <v-row class="ma-0">
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold">
                    {{ orderModule.order }} Information
                  </span>
                </v-col>
                <v-col cols="4" md="3">
                  <InputField
                    label="Reference Number"
                    :required="true"
                    name="reference_number"
                    v-model="orderDetails.reference_number"
                    :error-messages="formErrors.reference_number"
                    @input="delete formErrors.reference_number"
                  />
                </v-col>
                <!-- <v-col cols="4" md="3">
                  <SelectField
                    :label="`${orderModule.order} Type *`"
                    :itemsList="orderTypes"
                    name="order_type"
                    :rules="[
                      (val) => !!val || `${orderModule.order} Type is required`,
                    ]"
                    itemText="display_value"
                    itemValue="value"
                    v-model="orderDetails.order_type"
                    :error-messages="formErrors.order_type"
                    @input="delete formErrors.order_type"
                  />
                </v-col> -->
                <v-col cols="4" md="3">
                  <SelectField
                    :itemsList="branchList"
                    name="branch"
                    item-text="name"
                    item-value="id"
                    :label="`${configurationModule.branch}*`"
                    :rules="[
                      (val) =>
                        !!val || `${configurationModule.branch} is required`,
                    ]"
                    v-model="orderDetails.branch"
                    :error-messages="formErrors.branch"
                    @input="setAutoCompletedRestriction"
                    @change="
                      delete formErrors.branch;
                      getProjectSelectList($event);
                    "
                  />
                </v-col>
                <v-col cols="4" md="3">
                  <SelectField
                    :itemsList="projectList"
                    item-text="name"
                    item-value="id"
                    :label="`${configurationModule.project}*`"
                    :required="true"
                    :rules="[
                      (val) =>
                        !!val || `${configurationModule.project} is required`,
                    ]"
                    v-model="orderDetails.project"
                    :error-messages="formErrors.project"
                    @change="delete formErrors.project"
                  />
                </v-col>
                <v-col cols="4" md="3">
                  <DatePicker
                    type="date"
                    outlined
                    name="execution_date"
                    :label="`${orderModule.order} Date *`"
                    :min="returnToday()"
                    :rules="[
                      (val) => !!val || `${orderModule.order} Date is required`,
                    ]"
                    v-model="orderDetails.execution_date"
                    :error-messages="formErrors.execution_date"
                    @input="delete formErrors.execution_date"
                  />
                </v-col>

                <v-col
                  cols="4"
                  md="3"
                  v-if="
                    userDetails &&
                    userDetails.company_details &&
                    userDetails.company_details.configuration &&
                    !userDetails.company_details.configuration.has_items
                  "
                >
                  <InputField
                    type="number"
                    :label="`${orderModule.order} Volume`"
                    :required="true"
                    v-model="orderDetails.volume"
                    :error-messages="formErrors.volume"
                    @input="delete formErrors.volume"
                  />
                </v-col>
                <v-col
                  cols="4"
                  md="3"
                  v-if="
                    userDetails &&
                    userDetails.company_details &&
                    userDetails.company_details.configuration &&
                    !userDetails.company_details.configuration.has_items
                  "
                >
                  <InputField
                    type="number"
                    :label="`${orderModule.order} Weight`"
                    :required="true"
                    v-model="orderDetails.weight"
                    :error-messages="formErrors.weight"
                    @input="delete formErrors.weight"
                  />
                </v-col>
                <v-col cols="4" md="3">
                  <InputField
                    :label="`${orderModule.order} Remarks`"
                    name="order_remarks"
                    v-model="orderDetails.order_remarks"
                    :error-messages="formErrors.order_remarks"
                    @input="delete formErrors.order_remarks"
                  />
                </v-col>
                <v-col cols="4" md="3">
                  <SelectField
                    return-object
                    :itemsList="paymentMethodList"
                    name="payment_method"
                    label="Payment Method*"
                    item-text="name"
                    item-value="id"
                    :rules="[(val) => !!val || 'Payment Method is required']"
                    v-model="orderDetails.payment_method"
                    :error-messages="formErrors.payment_method"
                    @input="delete formErrors.payment_method"
                  />
                </v-col>
                <v-col
                  cols="4"
                  md="3"
                  v-if="
                    orderDetails.payment_method &&
                    orderDetails.payment_method.type == 'non_prepaid'
                  "
                >
                  <InputField
                    type="number"
                    min="0"
                    label="Order Value"
                    name="order_value"
                    :required="
                      orderDetails.payment_method &&
                      orderDetails.payment_method.type != 'prepaid'
                    "
                    v-model="orderDetails.order_value"
                    :error-messages="formErrors.order_value"
                    @input="delete formErrors.order_value"
                  />
                </v-col>
                <v-col cols="3" md="3">
                  <SwitchField
                    v-model="orderDetails.is_proof_of_delivery"
                    name="is_proof_of_delivery"
                    inset
                    class="mt-3 text-capitalize"
                    label="Order Attachment"
                  />
                </v-col>
                <v-col cols="3" md="3">
                  <SwitchField
                    v-model="orderDetails.otp_verification"
                    name="otp-verification"
                    inset
                    class="mt-3 text-capitalize"
                    label="Otp Verification Required"
                  />
                </v-col>
                <v-col cols="4" md="3">
                  <SwitchField
                    v-model="orderDetails.customer_barcode_scanning"
                    name="barcode-scanning"
                    inset
                    class="mt-3 text-capitalize"
                    label="Customer Barcode Scanning Reuqired"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="3"
                  v-if="orderDetails.customer_barcode_scanning"
                >
                  <InputField
                    label="Barcode Number"
                    v-model="orderDetails.barcode_number"
                    :error-messages="formErrors.barcode_number"
                    @input="delete formErrors.barcode_number"
                    :required="true"
                  />
                </v-col>
              </v-row>
            </v-card>
            <v-card elevation="0" class="mt-4 pa-4 rounded-lg">
              <v-row class="ma-0">
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold">
                    Pickup Information
                  </span>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-row class="pa-0 ma-0">
                    <v-col cols="4" md="6">
                      <InputField
                        :label="`Name`"
                        name="pickup_point_name"
                        :required="true"
                        v-model="orderDetails.pickup_point_name"
                        :error-messages="formErrors.pickup_point_name"
                        @input="delete formErrors.pickup_point_name"
                      />
                    </v-col>
                    <v-col cols="4" md="6">
                      <InputField
                        type="number"
                        min="0"
                        name="pickup_point_contact_number"
                        label="Contact Number"
                        v-model="orderDetails.pickup_point_contact_number"
                        :error-messages="formErrors.pickup_point_contact_number"
                        @input="delete formErrors.pickup_point_contact_number"
                      />
                    </v-col>
                    <v-col cols="4" md="6">
                      <InputField
                        type="time"
                        label="From Time"
                        name="pickup_point_from_time"
                        :required="true"
                        v-model="orderDetails.pickup_point_from_time"
                        :error-messages="formErrors.pickup_point_from_time"
                        @input="delete formErrors.pickup_point_from_time"
                      />
                    </v-col>
                    <v-col cols="4" md="6">
                      <InputField
                        type="time"
                        label="To Time"
                        :required="true"
                        name="pickup_point_to_time"
                        v-model="orderDetails.pickup_point_to_time"
                        :error-messages="formErrors.pickup_point_to_time"
                        @input="delete formErrors.pickup_point_to_time"
                      />
                    </v-col>
                    <v-col cols="4" md="6">
                      <InputField
                        type="number"
                        min="0"
                        label="Processing Time"
                        name="pickup_point_processing_time"
                        :required="true"
                        v-model="orderDetails.pickup_point_processing_time"
                        :error-messages="
                          formErrors.pickup_point_processing_time
                        "
                        @input="delete formErrors.pickup_point_processing_time"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="Pickup Address *"
                        name="pickup_address"
                        outlined
                        dense
                        ref="pickupAddress"
                        id="pickupAddress"
                        background-color="background_color"
                        hide-details="auto"
                        v-model="orderDetails.pickup_address"
                        :rules="[
                          (val) => !!val || 'Pickup Address is required',
                        ]"
                        :error-messages="formErrors.pickup_address"
                        @input="delete formErrors.pickup_address"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                      v-if="orderDetails && orderDetails.pickup_coordinates"
                    >
                      <InputField
                        label="Latitude"
                        name="latitude"
                        outlined
                        :required="true"
                        disabled
                        class="unassigned lighten-3"
                        hide-details="auto"
                        v-model="orderDetails.pickup_coordinates.latitude"
                      />
                    </v-col>

                    <v-col
                      cols="6"
                      v-if="orderDetails && orderDetails.pickup_coordinates"
                    >
                      <InputField
                        label="longitude"
                        name="longitude"
                        outlined
                        :required="true"
                        disabled
                        class="unassigned lighten-3"
                        hide-details="auto"
                        v-model="orderDetails.pickup_coordinates.longitude"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
            <v-card elevation="0" class="mt-4 pa-4 rounded-lg">
              <v-row class="ma-0">
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold">
                    Drop Information
                  </span>
                </v-col>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="4" md="6">
                      <InputField
                        :label="`Name`"
                        name="customer_name"
                        :required="true"
                        v-model="orderDetails.customer_name"
                        :error-messages="formErrors.customer_name"
                        @input="delete formErrors.customer_name"
                      />
                    </v-col>
                    <v-col cols="4" md="6">
                      <InputField
                        type="number"
                        min="0"
                        name="contact_number"
                        label="Contact Number"
                        :rules="[
                          (val) =>
                            (val && val.length >= 9 && val.length <= 12) ||
                            'Contact number should be between 9 to 12 digits!',
                        ]"
                        :required="true"
                        v-model="orderDetails.contact_number"
                        :error-messages="formErrors.contact_number"
                        @input="delete formErrors.contact_number"
                      />
                    </v-col>
                    <v-col cols="4" md="6">
                      <InputField
                        type="time"
                        label="From Time"
                        name="from_time"
                        :required="true"
                        v-model="orderDetails.from_time"
                        :error-messages="formErrors.from_time"
                        @input="delete formErrors.from_time"
                      />
                    </v-col>
                    <v-col cols="4" md="6">
                      <InputField
                        type="time"
                        label="To Time"
                        :required="true"
                        name="to_time"
                        v-model="orderDetails.to_time"
                        :error-messages="formErrors.to_time"
                        @input="delete formErrors.to_time"
                      />
                    </v-col>
                    <v-col cols="4" md="6">
                      <InputField
                        label="Contact Email"
                        name="contact_email"
                        :required="false"
                        :rules="[
                          (v) => !v || emailValidation(v) || 'Invalid email id',
                        ]"
                        v-model="orderDetails.contact_email"
                        :error-messages="formErrors.contact_email"
                        @input="delete formErrors.contact_email"
                      />
                    </v-col>
                    <v-col cols="4" md="6">
                      <InputField
                        type="number"
                        min="0"
                        label="Processing Time"
                        name="processing_time"
                        :required="true"
                        v-model="orderDetails.processing_time"
                        :error-messages="formErrors.processing_time"
                        @input="delete formErrors.processing_time"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="Drop Address *"
                        outlined
                        name="drop_address"
                        dense
                        background-color="background_color"
                        ref="dropAddress"
                        id="dropAddress"
                        hide-details="auto"
                        v-model="orderDetails.drop_address"
                        :rules="[(val) => !!val || 'Drop Address is required']"
                        :error-messages="formErrors.drop_address"
                        @input="delete formErrors.drop_address"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                      v-if="orderDetails && orderDetails.drop_coordinates"
                    >
                      <InputField
                        label="Latitude"
                        name="latitude"
                        outlined
                        :required="true"
                        disabled
                        class="unassigned lighten-3"
                        hide-details="auto"
                        v-model="orderDetails.drop_coordinates.latitude"
                      />
                    </v-col>

                    <v-col
                      cols="6"
                      v-if="orderDetails && orderDetails.drop_coordinates"
                    >
                      <InputField
                        label="longitude"
                        name="longitude"
                        outlined
                        :required="true"
                        disabled
                        class="unassigned lighten-3"
                        hide-details="auto"
                        v-model="orderDetails.drop_coordinates.longitude"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>

            <v-card
              elevation="0"
              class="mt-4 pa-4 rounded-lg"
              v-if="
                userDetails &&
                userDetails.company_details &&
                userDetails.company_details.configuration &&
                userDetails.company_details.configuration.has_items
              "
            >
              <v-row class="ma-0">
                <v-col cols="6" class="d-flex align-center">
                  <span class="text-subtitle-1 font-weight-bold">
                    {{ orderModule.order }} Items
                  </span>
                </v-col>
                <v-col cols="6" class="d-flex justify-end align-center">
                  <v-chip class="mr-2 primary" small
                    ><span class="text-capitalize mr-2">total Volume</span
                    >{{ orderCbm }} CBM</v-chip
                  >
                  <v-chip class="mr-6 primary" small
                    ><span class="text-capitalize mr-2">total Weight</span
                    >{{ orderWeight }} Kg</v-chip
                  >
                  <PrimaryButton name="Add Item" @click="addItem()">
                    Add Item
                  </PrimaryButton>
                </v-col>
              </v-row>
              <v-row
                class="ma-0"
                v-for="(item, itemIndex) in orderDetails.order_items"
                :key="itemIndex"
              >
                <v-col cols="11" class="pa-0">
                  <v-row class="ma-0">
                    <v-col cols="4">
                      <SelectField
                        class="custom-list"
                        :disabled="item.disabled"
                        :class="
                          item.disabled
                            ? 'unassigned lighten-3'
                            : 'background_color'
                        "
                        :itemsList="itemList"
                        :return-object="true"
                        :item-disabled="
                          (item) => selectedItemIds.indexOf(item.id) > -1
                        "
                        :name="`${itemIndex}_item`"
                        item-text="item_no"
                        item-value="id"
                        label="Item *"
                        v-model="item.item"
                        :rules="[(val) => !!val || 'Item is required']"
                        :error-messages="
                          errorInSubArrayHandler(
                            formErrors,
                            'order_items',
                            itemIndex,
                            'item'
                          )
                        "
                        @input="
                          errorInSubArrayHandler(
                            formErrors,
                            'order_items',
                            itemIndex,
                            'item',
                            true
                          )
                        "
                      />
                    </v-col>
                    <v-col cols="4">
                      <InputField
                        type="number"
                        label="Quantity"
                        :required="true"
                        :name="`${itemIndex}_original_quantity`"
                        :rules="[minOrderQuantity]"
                        v-model="item.original_quantity"
                        :error-messages="
                          errorInSubArrayHandler(
                            formErrors,
                            'order_items',
                            itemIndex,
                            'original_quantity'
                          )
                        "
                        @input="
                          errorInSubArrayHandler(
                            formErrors,
                            'order_items',
                            itemIndex,
                            'original_quantity',
                            true
                          )
                        "
                      />
                    </v-col>
                    <v-col cols="3" class="d-flex">
                      <v-chip
                        class="w-100 white mr-2"
                        filter
                        label
                        v-show="item.original_quantity"
                      >
                        {{
                          (
                            parseFloat(item.original_quantity) *
                            (item && item.item && item.item.volume
                              ? parseFloat(item.item.volume)
                              : item && item.item_volume
                              ? parseFloat(item.item_volume)
                              : 0)
                          ).toFixed(4)
                        }}
                        CBM
                      </v-chip>
                      <v-chip
                        class="w-100 white mr-2"
                        filter
                        label
                        v-show="item.original_quantity"
                      >
                        {{
                          (
                            parseFloat(item.original_quantity) *
                            (item && item.item && item.item.weight
                              ? parseFloat(item.item.weight)
                              : item && item.item_weight
                              ? parseFloat(item.item_weight)
                              : 0)
                          ).toFixed(2)
                        }}
                        KG
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="1" class="d-flex justify-end align-center">
                  <PrimaryButton
                    :disabled="orderDetails.order_items.length < 2"
                    color="error"
                    @click="removeItem(itemIndex)"
                    name="Remove"
                  >
                  </PrimaryButton>
                </v-col>
              </v-row>
            </v-card>

            <v-row
              class="mt-4 mt-lg-0"
              v-if="customOptionFieldList && customOptionFieldList.length > 0"
            >
              <v-col cols="12">
                <CustomFieldRenderForm
                  :fieldList="customOptionFieldList"
                  :formObject="customObject"
                  :fieldsErrors="customFieldsErrors"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col
            cols="3"
            class="overflow-y-auto"
            style="height: calc(100vh - 190px)"
            v-if="orderDetails && orderDetails.trip_details"
          >
            <v-row no-gutters>
              <v-col cols="12">
                <!-- <v-expand-transition>
                  <div
                    v-show="isOverloadCBM"
                    class="rounded-lg mb-4"
                    :style="`border: 3px dashed var(--v-error-lighten2)`"
                  >
                    <v-card elevation="0" class="px-4 py-5 error lighten-5">
                      <v-row class="" style="transition: all 0.3s ease">
                        <v-col cols="2" class="text-center">
                          <v-icon color="error lighten-3">
                            mdi-information
                          </v-icon>
                        </v-col>
                        <v-col cols="10" class="d-flex align-center">
                          <h5 class="text-capitalize">
                            Total item CBM is more then vehicle capacity.
                          </h5>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-expand-transition>
                <v-expand-transition>
                  <div
                    v-show="isOverloadWeight"
                    class="rounded-lg mb-3"
                    :style="`border: 3px dashed var(--v-error-lighten2)`"
                  >
                    <v-card elevation="0" class="px-4 py-5 error lighten-5">
                      <v-row class="" style="transition: all 0.3s ease">
                        <v-col cols="2" class="text-center">
                          <v-icon color="error lighten-3">
                            mdi-information
                          </v-icon>
                        </v-col>
                        <v-col cols="10" class="d-flex align-center">
                          <h5 class="text-capitalize">
                            Total item Weight is more then vehicle capacity.
                          </h5>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-expand-transition> -->
              </v-col>
              <v-col cols="12" v-if="orderDetails && orderDetails.trip_details">
                <v-expansion-panels
                  v-model="tripInfoExpansion"
                  flat
                  class="app-list-card-expansion"
                >
                  <v-expansion-panel
                    elevation="0"
                    class="ma-0 mb-2 card-box-shadow"
                  >
                    <v-expansion-panel-header
                      class="px-3 py-0 ma-0 app-list-card-expansion-header"
                    >
                      <h5 class="text-caption py-2 font-weight-bold">
                        {{ tripModule.trip }} Info
                      </h5>
                    </v-expansion-panel-header>
                    <v-divider></v-divider>
                    <v-expansion-panel-content
                      class="pa-0"
                      v-for="(value, key, index) in orderDetails.trip_details"
                      :key="index"
                    >
                      <v-card
                        elevation="0"
                        class="pa-0 ma-0"
                        v-if="key != 'status'"
                      >
                        <v-card-subtitle class="py-1 ma-0">
                          <v-row no-gutters>
                            <v-col cols="6">
                              <h5 class="text-left text-capitalize" v-if="key">
                                {{ key.replace(/_/g, "  ") }}
                              </h5>
                            </v-col>
                            <v-col cols="6">
                              <h6
                                class="text-caption black--text text-center"
                                v-if="key == 'reference_number'"
                              >
                                {{ value }}
                                <v-chip
                                  class="mr-1 text-capitalize white--text font-weight-bold"
                                  x-small
                                  :class="
                                    $helper.tripStatusColor(tripDetails.status)
                                  "
                                  v-if="tripDetails.status"
                                >
                                  {{ tripDetails.status }}
                                </v-chip>
                              </h6>
                              <h6
                                class="text-caption black--text text-center"
                                v-else
                              >
                                {{ value }}
                              </h6>
                            </v-col>
                          </v-row>
                        </v-card-subtitle>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </BaseFormLayout>
</template>

<script>
import { bus } from "@/main.js";
import { minOrderQuantity } from "@/utils/validation";
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import {
  emailValidation,
  errorInSubArrayHandler,
  loadGoogleInstance,
  returnToday,
  referenceValidation,
  customFieldDefaultData,
} from "@/utils/functions";
import {
  tripModule,
  configurationModule,
  customerModule,
  orderModule,
} from "@/utils/moduleMapping";

export default {
  components: {
    BaseFormLayout,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      required: true,
    },
  },
  data() {
    return {
      customFieldDefaultData,
      referenceValidation,
      tripModule,
      orderModule,
      emailValidation,
      errorInSubArrayHandler,
      configurationModule,
      customerModule,
      minOrderQuantity,
      returnToday,
      fileInput: null,
      tripInfoExpansion: 0,
      formCount: 0,
      isValid: true,
      orderDetails: {
        customer_barcode_scanning: false,
      },
      orderSelectedBranch: null,
      formErrors: {},

      itemList: [],
      branchList: [],
      warehouseList: [],
      customerAddressList: [],
      customerList: [],
      selectedCustomer: null,
      paymentMethodList: [],

      pickupAddressInstance: null,
      dropAddressInstance: null,

      orderTypes: [],

      projectList: [],
      customOptionFieldList: [],
      customFieldsErrors: {},
      customObject: {},
    };
  },
  computed: {
    orderWeight() {
      if (this.orderDetails.order_items) {
        return this.orderDetails.order_items
          .map((v) =>
            v && v.item_weight
              ? v.item_weight *
                parseFloat(v.original_quantity ? v.original_quantity : 0)
              : v && v.item && v.item.weight
              ? v.item.weight *
                parseFloat(v.original_quantity ? v.original_quantity : 0)
              : null
          )
          .filter((v) => v != null)
          .reduce((p, c) => parseFloat(p) + parseFloat(c), 0)
          .toFixed(2);
      }
    },
    orderCbm() {
      if (this.orderDetails.order_items) {
        return this.orderDetails.order_items
          .map((v) =>
            v && v.item_volume
              ? v.item_volume *
                parseFloat(v.original_quantity ? v.original_quantity : 0)
              : v && v.item && v.item.volume
              ? v.item.volume *
                parseFloat(v.original_quantity ? v.original_quantity : 0)
              : null
          )
          .filter((v) => v != null)
          .reduce((p, c) => parseFloat(p) + parseFloat(c), 0)
          .toFixed(4);
      }
    },
    tripDetails() {
      return this.orderDetails?.trip_details;
    },
    selectedBranch() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj.preferred_branch.id;
      } else {
        return null;
      }
    },
    userDetails() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj;
      }
    },
    selectedItemIds() {
      return this.orderDetails.order_items.map((itemObj) => {
        if (typeof itemObj.item == typeof {}) {
          return itemObj.item.id;
        } else {
          return itemObj.item;
        }
      });
    },
  },
  methods: {
    getOrderOptions() {
      bus.$emit("showLoader", true);
      this.$api.orderNew
        .getOrderOptions({ request_type: "filter" })
        .then((res) => {
          this.orderTypes = res?.data?.order_type;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    addItem() {
      this.orderDetails.order_items.push({});
    },
    removeItem(index) {
      this.orderDetails.order_items.splice(index, 1);
    },
    resetForm() {
      this.$refs.orderForm.resetValidation();

      this.orderDetails = {
        is_proof_of_delivery: false,
        order_items: [{}],
        pickup_coordinates: {},
        drop_coordinates: {},
        branch: this.selectedBranch,
      };
      this.getOrderAdhocOptions();
    },
    getOrderObject(id) {
      bus.$emit("showLoader", true);
      this.$api.orderNew
        .getOrderObject(id)
        .then((res) => {
          let orderData = res.data;

          if (
            res &&
            res.data &&
            res.data.custom_fields &&
            Object.keys(res.data.custom_fields).length > 0
          ) {
            this.customObject = res.data.custom_fields;
          }

          if (this.userDetails.company_details.configuration.has_items) {
            let orderItem = [];
            let i;
            if (
              res &&
              res.data &&
              res.data.order_items &&
              res.data.order_items.length > 0
            ) {
              for (i = 0; i < res.data.order_items.length; i++) {
                orderItem.push({ ...res.data.order_items[i], disabled: true });
              }
            }

            orderData.order_items = orderItem;
          }
          this.orderDetails = orderData;
          if (this.orderDetails && this.orderDetails.payment_method) {
            this.orderDetails.payment_method = this.paymentMethodList.find(
              (v) => v.id == this.orderDetails.payment_method
            );
          }
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    submitForm() {
      if (!this.$refs.orderForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }

      let data = JSON.parse(JSON.stringify(this.orderDetails));

      data = {
        ...data,
        custom_fields: this.customObject,
      };

      if (this.userDetails.company_details.configuration.has_items) {
        if (data && data.order_items) {
          data.order_items ==
            data.order_items.map((v) => {
              if (!v.status) {
                v.item = v && v.item && v.item.id ? v.item.id : null;
              }
              return v;
            });
        }
      }

      if (
        data &&
        data.payment_method &&
        typeof data.payment_method === "object" &&
        data.payment_method.id
      ) {
        data.payment_method = data.payment_method.id;
      }

      bus.$emit("showLoader", true);
      if (this.editMode) {
        this.$api.orderNew
          .updateOrderObject(this.orderDetails.id, {
            order_type: this.orderDetails.order_type,
            order_segment: "adhoc",
            has_items: this.userDetails.company_details.configuration.has_items,
            payload: data,
          })
          .then(() => {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Order information updated!",
              color: "success",
            });
            this.resetForm();
            this.$router.back();
          })
          .catch((err) => {
            bus.$emit("showLoader", false);
            this.formErrors = { order_items: [], ...err.data };
            this.customFieldsErrors = err?.data?.custom_fields;
          });
      } else {
        this.$api.orderNew
          .createOrderObject({
            order_type: this.orderDetails.order_type,
            order_segment: "adhoc",
            has_items: this.userDetails.company_details.configuration.has_items,
            payload: data,
          })
          .then(() => {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Order created!",
              color: "success",
            });
            this.resetForm();
            this.$router.back();
          })
          .catch((err) => {
            bus.$emit("showLoader", false);
            this.formErrors = { order_items: [], ...err.data };
            this.customFieldsErrors = err?.data?.custom_fields;
          });
      }
    },
    getBranchList() {
      return this.$api.branch
        .getBranchSelectList({ limit: "all" })
        .then((res) => {
          this.branchList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPaymentMethodList() {
      return this.$api.paymentMethod
        .getPaymentMethodSelectList({ limit: "all" })
        .then((res) => {
          this.paymentMethodList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getItemList() {
      return this.$api.item
        .getItemSelectList({ limit: "all" })
        .then((res) => {
          this.itemList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLists() {
      bus.$emit("showLoader", true);
      let allPromises = [this.getBranchList(), this.getPaymentMethodList()];
      if (this.userDetails.company_details.configuration.has_items) {
        allPromises.push(this.getItemList());
      }
      Promise.all(allPromises)
        .then(() => {
          if (this.$route && this.$route.params && this.$route.params.id) {
            this.getOrderObject(this.$route.params.id);
          }
          bus.$emit("showLoader", false);
        })
        .catch(() => {
          bus.$emit("showLoader", false);
        });
    },
    loadAutoComplete() {
      const interval = setInterval(async () => {
        if (
          window.google &&
          window.google.maps &&
          this.$refs.pickupAddress &&
          this.$refs.dropAddress
        ) {
          clearInterval(interval);
          this.loadInstance("pickup");
          this.loadInstance("drop");
          this.setAutoCompletedRestriction();
        } else {
          loadGoogleInstance();
        }
      }, 100);
    },
    setAutoCompletedRestriction() {
      if (this.orderDetails.branch && this.branchList) {
        let branch = this.branchList.find(
          (v) => v.id == this.orderDetails.branch
        );
        if (branch && branch.country_code) {
          this[`pickupAddressInstance`].setComponentRestrictions({
            country: [branch.country_code],
          });
          this[`dropAddressInstance`].setComponentRestrictions({
            country: [branch.country_code],
          });
        } else {
        }
      }
    },
    loadInstance(type) {
      let address = document.getElementById(`${type}Address`);

      this[`${type}AddressInstance`] =
        new window.google.maps.places.Autocomplete(address);

      address.setAttribute("placeholder", "");

      let userDetails = this.$helper.getUserDetailsLocalStorage();
      if (userDetails) {
        this[`${type}AddressInstance`].setComponentRestrictions({
          country: [userDetails.preferred_branch.country_code],
        });
      }

      this[`${type}AddressInstance`].addListener("place_changed", () => {
        let place = this[`${type}AddressInstance`].getPlace();

        let obj = {};

        obj[`${type}_coordinates`] = {
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
        };
        obj[`${type}_address`] = place.formatted_address;

        this.orderDetails = {
          ...this.orderDetails,
          ...obj,
        };
      });
    },
    getProjectSelectList(id) {
      if (id) {
        this.$api.project
          .getProjectSelectList({ limit: "all", branch: id })
          .then((res) => {
            this.projectList = res.data;
            let defaultProject = this.projectList.find((v) => v.is_default);
            this.orderDetails.project = defaultProject?.id;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.projectList = [];
      }
    },
    getOrderAdhocOptions() {
      this.getOrderOptions();
      bus.$emit("showLoader", true);
      return this.$api.orderNew
        .getOrderOptions({ request_type: "form" })
        .then((res) => {
          this.customOptionFieldList = res?.data?.custom_fields;
          this.customObject = this.customFieldDefaultData(
            this.customOptionFieldList
          );
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  async mounted() {
    await this.getOrderAdhocOptions();
    this.getLists();
    let barcodeScanning =
      this.userDetails?.company_details?.configuration
        ?.customer_barcode_scanning;
    this.orderDetails.customer_barcode_scanning = barcodeScanning;

    let otpVerification =
      this.userDetails?.company_details?.configuration?.otp_verification;
    this.orderDetails.otp_verification = otpVerification;

    if (this.userDetails.company_details.configuration.has_items) {
      this.orderDetails = {
        ...this.orderDetails,
        order_items: [{}],
        pickup_coordinates: {},
        drop_coordinates: {},
      };
      this.formErrors = {
        order_items: [],
      };
    }
    this.loadAutoComplete();
    this.getOrderOptions();
    if (this.selectedBranch && !this.editMode) {
      this.orderDetails.branch = this.selectedBranch;
    }
    if (this.selectedBranch) {
      this.getProjectSelectList(this.selectedBranch);
    }
  },
};
</script>

<style>
.v-select__slot label {
  z-index: 2;
}
.custom-list.theme--light.v-select .v-select__selection--disabled {
  color: black !important;
}
</style>
